import {useRouter} from "next/router"
import {useEffect} from "react"

// This page was the old way to view lead pages. This
// has now been moved to /external/leadPage/[pageCode].tsx
// This route only serves as a redirect to preserve any urls
// using this old schema
export default function GoogleBusinessLeadPage(
): JSX.Element {
    const router = useRouter()

    useEffect(() => {
        if (!router.query.pageCode) {
            return
        }
        const redirect = `/external/leadPage/${router.query.pageCode}`
        console.log("red", redirect)
        router.push(redirect)
    }, [router])
    
    return <></>
}